module.exports = __webpack_public_path__ + "img/c50e2e3.png";